// export const emailAddresses = ['bizapps@codeparva.in', 'support@syrasoft.com'];
export const baseURL = 'https://emailsvc-ext.syrasoft.com/v1/email';
export const emailAddresses = [
  'sanghmitra.v@codeparva.in',
  'jaya13194@gmail.com',
];
export const IconConfig = {
  iconSizeContactUs: 32,
  successIconSize: 23,
  successIconColor: '#86c023',
};
